import { render, staticRenderFns } from "./recruit-table.vue?vue&type=template&id=12f748b6&scoped=true&"
import script from "./recruit-table.vue?vue&type=script&lang=js&"
export * from "./recruit-table.vue?vue&type=script&lang=js&"
import style0 from "./recruit-table.vue?vue&type=style&index=0&id=12f748b6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f748b6",
  null
  
)

export default component.exports